import computeSimpleValue from "./compute-simple-value";
import getValueOutput from "./get-value-output";

/**
 * Compute values inside a function (`clip-path(0% 100%, 50% 10%)`)
 * @param {Number} progress
 * @param {PropertyValueProps} item Active item
 * @param {PropertyValueProps} initial Initial value
 * @param {Array<String | Array<String>>} array
 * @returns
 */
const computeFnValues = (progress, item, initial, array) => {
  let index = 0;

  const inner = [];

  const initialIsCalc = initial.get("v_is-calc");

  const isInherit = item.get("v_is-inherit");

  const isCalc = item.get("v_is-calc");

  let activeValues = /** @type {Array<Map<String, any>>} */ (
    item.get("v_values")
  );

  const initialValues = /** @type {Array<Map<String, any>>} */ (
    initial.get("v_values")
  );

  // TODO: test for multiple triggers (multiple linear-gradient triggers)
  if (isInherit) {
    activeValues = initialValues;
  }

  /**
   * When initial is calc() function, it is automatically looking for the multiple items
   * in the "active" property. Because the calc has `(number + number)` it is also checking
   * for two items. But when the active value is only a one, it has no `values` array
   */
  if (initialIsCalc && !activeValues) {
    const output = getValueOutput(initial, null);
    const computed = computeSimpleValue(progress, item, output, array, index);

    return [computed];
  }

  if (initialIsCalc && isCalc) {
    const output = initial.get("v_original");
    const activeValue = /** @type {PropertyValueProps} */ (item);
    const computed = computeSimpleValue(
      progress,
      activeValue,
      output,
      array,
      index
    );

    inner.push(computed);
  } else {
    for (const initialValue of initialValues) {
      const output = initialValue.get("v_output");
      const activeValue = /** @type {PropertyValueProps} */ (
        activeValues[index]
      );
      const computed = computeSimpleValue(
        progress,
        activeValue,
        output,
        array,
        index
      );

      inner.push(computed);

      ++index;
    }
  }

  return inner;
};

export default computeFnValues;
